import React from 'react';
import { Table } from 'reactstrap';
import Presenter from '../../../presenter.js';
import RequestProperties from '../../request.props.js';

// Component
import TrackingRow from '../Row/TrackingRow.js';
import windowStop from 'utils/windowStop.js'

export default class TabTracking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      RowElement      : [],
      loadingLoadMore : true,
      NextPage        : null,
      Data : {
        count: 0,
        results: [],
      },
    }
    
    this.loading = true;
  }

  generateRow(row) {
    var element = row.map((val, index) => {
      return (<TrackingRow RowData={val} key={index}></TrackingRow>)
    })
    return element;
  }

  loadTracking() {
    Presenter.ReadTracking(
      RequestProperties.ReadTrackingProps("Read", this, this.OnReadTrackingSuccess, this.OnReadTrackingFailed)
    )
  }

  OnReadTrackingSuccess(params, response){
    if(params.action === 'Read') {
      let tmpData = {};
      tmpData.count    = response.data.count;
      tmpData.results  = response.data.results;
      params.self.loading = false;
      params.self.setState({
        loadingLoadMore : false,
        NextPage        : response.data.next,
        Data            : tmpData,
        RowElement      : params.self.generateRow(response.data.results)
      })
  } else {
      let newData = {};
      newData.count    = response.data.count;
      newData.results  = params.self.state.Data.results.concat(response.data.results);
      params.self.loading = false;
      params.self.setState({
        loadingLoadMore : false,
        NextPage        : response.data.next,
        Data            : newData,
        RowElement      : params.self.generateRow([...params.self.state.Data.results, ...response.data.results])
      })

    }

  }

  OnReadTrackingFailed(response){

  }

  // LOADMORE
  LoadMore() {                
    this.setState({
      loadingLoadMore: true,
    })
    Presenter.ReadTracking( 
      RequestProperties.ReadTrackingProps("Next", this, this.OnReadTrackingSuccess, this.OnReadTrackingFailed) 
    )
  }

  RenderLoadMoreButton() {
    if(this.state.loadingLoadMore) {
      return(
        <div>
          <button className="btn btn-default" disabled><i className="fa fa-spinner fa-pulse fa-fw"></i>&nbsp;Loading</button>
        </div>
      )
    } else {
      if(this.state.NextPage != null) {
        return (
          <div>
            <button className="btn btn-primary" onClick={()=> {this.LoadMore()}}>Load More</button>
          </div>
        )
      }
    }
  }

  componentDidMount() {
    this.loadTracking();
  }

  componentWillUnmount() {
    windowStop()
  }

  RenderRowElement() {
    if(this.loading) {
      return (        
        <tr>
          <td className="table-loading-inside" colSpan="100%">Loading data . . .</td>
        </tr>
      )
    } else if(this.state.RowElement.length > 0) {
        return (this.state.RowElement)
    } else {
      return (
        <tr>
          <td className="table-not-found" colSpan="100%"><span className="icon-drawer"></span>&nbsp;data empty</td>
        </tr>
      )
    }
  }

  render() {
    return (
      <div>
        <div className="list-separator"><div className="item-inner">Asset Tracking</div></div>
        <Table className="table table-striped table-responsive m-top-15">
          <thead>
            <tr>
              <th>Site</th>
              <th>Location</th>
              <th>Due Date</th>
              <th>Assigned</th>
              <th>Chekin Time</th>
              <th>Checkout Time</th>
            </tr>
          </thead>
          <tbody>
            {this.RenderRowElement()}
          </tbody>
        </Table>
        <div className="col-md-12 text-center">
          {this.RenderLoadMoreButton()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/asset/simple_asset/helper/component/Tab/TabTracking.js